import React from "react";
import { useDisclosure, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { AssetListingConfig } from "./AssetListingConfig";
import { EditAssetListingColumnsConfigDialog } from "./EditAssetListingColumnsConfigDialog";

export interface EditAssetListingColumnsConfigButtonProps {
    pageSize: number;
    setPageSize(pageSize: number): void;
    listingConfig: AssetListingConfig;
    saveListingConfig(cfg: AssetListingConfig): void;
}

export const EditAssetListingColumnsConfigButton: React.FC<EditAssetListingColumnsConfigButtonProps> = (
    props: EditAssetListingColumnsConfigButtonProps
) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsRead]}>
            <CommandBarButton icon={"Settings"} onClick={onOpen} text={`Config`} />
            {isOpen && (
                <EditAssetListingColumnsConfigDialog
                    onClose={onClose}
                    pageSize={props.pageSize}
                    setPageSize={props.setPageSize}
                    listingConfig={props.listingConfig}
                    saveListingConfig={props.saveListingConfig}
                />
            )}
        </AuthorizationWrapper>
    );
};
